<template>
    <div>
      <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
        <v-system-bar height="30" color="#fff" class="px-0">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon size="32" class="pt-5" @click="close">mdi-close</v-icon>
        </v-system-bar>
        <v-card-title class="cardTitle">
          <H5>
            {{ $t("message.superuser.updateprofile", { value: "default" }) }}
          </H5></v-card-title
        >
        <v-card-text>
          <template>
              <v-container class="checkboxContainer" fluid>
                <v-radio-group v-model="user.profil" @change="change" mandatory>
                  <v-radio
                    label="Administrator"
                    value="admin"
                  ><span slot="label">{{ $t("message.superuser.administrator", { value: "default" }) }}</span>
                </v-radio>
                  <v-radio
                    label="Management"
                    value="mgt"
                  ><span slot="label">{{ $t("message.superuser.management", { value: "default" }) }}</span>
                </v-radio>
                  <v-radio
                    label="Operationnel"
                    value="oper"
                  ><span slot="label">{{ $t("message.superuser.operational", { value: "default" }) }}</span>
                </v-radio>
                  <v-radio
                    label="Commercial"
                    value="com"
                  ><span slot="label">{{ $t("message.superuser.commercial", { value: "default" }) }}</span>
                </v-radio>
                </v-radio-group> 
              </v-container>

              <div class="mb-5 profil-legend">
                <div>

                  <span><b>* {{ $t("message.superuser.legendmgt", { value: "default" }) }}</b></span>
                </div>
                <div>
                  
                  <span><b>* {{ $t("message.superuser.legendcom", { value: "default" }) }}</b></span>
                </div>          
                <div>
                  
                  <span><b>* {{ $t("message.superuser.legendoper", { value: "default" }) }}</b></span>
                </div>
              </div>
              <div class="btn">
                <v-btn class="mr-2" color="#CCD2D5" @click="cancel">{{
                  $t("message.button.cancel", { value: "default" })
                }}</v-btn>
                <v-btn color="#00475A" dark @click="validate" >{{
                  $t("message.button.submit", { value: "default" })
                }}</v-btn>
              </div>
          </template>

        </v-card-text>



      </v-card>

      

    </div>
  </template>

<script>
import TeamsService from "@/services/TeamsService";
export default {
    props: ["user"],
    data() {
        return {
            edituserDialog:  false,
            radio: null,
            type: "info",
            message: "",
            SuperUser: false,
            Management: false,
            Operationnel: false,
            Commercial: false,
        };
    },
    
    methods: {

      change(event){
        this.radio = event
      },
        close() {
            this.$emit("editClose", this.type);
        },
        cancel() {
            this.$emit("editClose", this.type);
        },

        validate() {
          TeamsService.updateUserRoleClient(this.user.id, this.user.roleid, this.radio).then(() => {
                this.$emit("editClose", this.type);
            }).catch(() => {
            this.message = this.$t("message.magic.error", { value: "default" });
            this.type = "error";
            });
        },
    },

}
</script>

<style scoped>
.label-field {
  color: #00475a;
  font: normal normal bold 16px/19px Calibri;
}


.profil-legend {
  display: flex !important;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
}

.profil-legend-shape {
  height: 10px;
  width: 30px;
  display: inline-block;
}


.profil-legend-text {
  margin: 0 30px 0 5px;
}

.checkboxContainer .v-input {
  margin-top: 0px;
}

.checkboxContainer {
  padding: 0px 0px 0px 5px;
}

.cardTitle {
  padding-bottom: 0px;
}

.btn {
 display: flex;
 justify-content: space-around;
}

</style>